import React from 'react';
import { useNavigate } from 'react-router-dom';
import FeaturedSolutions, { AgilysysLogo } from '../components/FeaturedSolutions';

const A = '/assets/casino/solutions/';

const solutions = [
  { name: 'IG Fly',        path: 'ig-fly',        screenshot: A + 'fly-tap-pay.png' },
  { name: 'IG OnDemand',   path: 'ig-on-demand',  screenshot: A + 'app-ondemand-food.png' },
  { name: 'IG Quick Pay',  path: 'ig-quick-pay',  screenshot: A + 'app-qr-quickpay.png' },
  { name: 'IG Smart Menu', path: 'ig-smart-menu', screenshot: A + 'app-order-menu.png' },
  { name: 'Reserve',       path: 'reserve',       screenshot: A + 'app-tennis.png' },
];

function Tennis() {
  const navigate = useNavigate();
  return (
    <div className="page splash tennisPage">
      <div className="background" />
      <div className="page-header">Tennis Court</div>
      <div className="text-blocks">
        <div className="std-text">
          Serve up a winning player experience. Whether it's booking a court time, scheduling a lesson or providing courtside refreshments, you need a flexible, configurable solution.
        </div>
      </div>
      <FeaturedSolutions>
        {solutions.map((sol) => (
          <div key={sol.path} className="featured-item" onClick={() => navigate(`/solutions/${sol.path}`)}>
            <div className="item-head"><AgilysysLogo />{sol.name}</div>
            <img src={sol.screenshot} alt={sol.name} />
          </div>
        ))}
      </FeaturedSolutions>
    </div>
  );
}

export default Tennis;
